const identity = x => x;

export { identity };
